import MyEmitter from "events";
import storage from "utils/Storage";
import socket from "utils/Socket";
import C from 'utils/Constant';
import { Event, encode, decode, forceSatoshiFormat } from 'utils/Helper';

/**
 * Game Engine
 */
function Engine(){

    var self = this;

    /**
     * Game Name
     */
    self.game = 'SNAKEANDLADDERS';

    /**
     * Socket Connection
     */
    self.ws = socket;

    /**
     * Itialize Game
     */
    self.trigger = new MyEmitter();

    /**
     * Itialize Game
     */
    self.init = false;

    /**
     * Round Amount
     */
    self.amount = null;

    /**
     * Round Profit
     */
    self.profit = null;

    /**
     * Player Coin
     */
    self.coin = null;

    /**
     * Selected Land
     */
    self.land = null;

    /**
     * Current Land
     */
    self.currentLand = 89;

    /**
     * Player lost or win
     */
    self.lost = false;

    /*
     * Start Engine
    */
    self.started = true;

    if(self.started)
    {
        self.ws.on(C.PLAY_SNAKEANDLADDERS, (data) => {
            data = decode(data);

            switch(data.command)
            {
                case 'play':
                    return self.trigger.emit(C.PLAY_SNAKEANDLADDERS, data);
                case 'next':
                    return self.trigger.emit(C.NEXT_SNAKEANDLADDERS, data);
                case 'busted':
                    return self.trigger.emit(C.BUSTED_SNAKEANDLADDERS, data);
                case 'clicked':
                    return self.trigger.emit(C.CLICKED_SNAKEANDLADDERS, data);
                case 'cashout':
                    return self.trigger.emit(C.CASHOUT_SNAKEANDLADDERS, data);
                case 'error':
                    return self.trigger.emit(C.ERORR_SNAKEANDLADDERS, data);
            }
        });
    }
}

Engine.prototype.off = function (){
    let self = this;
    self.ws.off(C.PLAY_SNAKEANDLADDERS);
}

Engine.prototype.on = function (name, callback){
    let self = this;
    if(!self.started) return;
    if(self.trigger === null) return;
        return self.trigger.on(name, (data) => callback(data));
}

Engine.prototype.emit = function (name, data = []){
    let self = this;
    if(!self.started) return;
    if(self.trigger === null) return;
        return self.trigger.emit(name, data);
}

/**
 * Start Game
 */
Engine.prototype.start = function () {
    let self = this;

    if(!self.init)
        return;

    if(self.amount < 0.00000010){
        self.amount = forceSatoshiFormat(0.00000010)
    }
    
    self.ws.emit(C.PLAY_SNAKEANDLADDERS, encode({
        command: 'play',
        amount: self.amount,
        coin: self.coin
    }));
};

/**
 * Clicked On the Land
 */
Engine.prototype.clicked = function () {
    let self = this;
    self.ws.emit(C.PLAY_SNAKEANDLADDERS, encode({
        command: 'clicked',
        land: self.land,
        lost: self.lost
    }));
};

/**
 * Next roll
 */
Engine.prototype.next = function () {
    let self = this;
    self.ws.emit(C.PLAY_SNAKEANDLADDERS, encode({
        command: 'next',
        currentLand: self.currentLand,
        profit: self.profit
    }));
};

/**
 * CashOut
 */
Engine.prototype.cashout = function () {
    let self = this;
    self.ws.emit(C.PLAY_SNAKEANDLADDERS, encode({
        command: 'cashout',
        profit: self.profit
    }));
};

/** Start Game Engine **/
export default Engine
